var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "spa-checkout-sidebar" },
    [
      _c(
        "section",
        {
          staticClass: "spa-checkout-sidebar__section",
          attrs: { id: "guest-date-section" },
        },
        [
          _c("div", [
            _c("h3", { staticClass: "spa-checkout-sidebar__title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("spaSoft.step2.stayDetailsGuests")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "spa-checkout-sidebar__text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(Object.keys(_vm.guestsSelectedData).length) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "spa-checkout-sidebar__title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("spaSoft.step2.stayDetailsDate")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "spa-checkout-sidebar__text" }, [
              _vm._v("\n        " + _vm._s(_vm.dateFormatted) + "\n      "),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.guestsSelectedData, function (guest, guestIndex) {
        return _c(
          "section",
          {
            key: "guest-" + guestIndex,
            staticClass: "spa-checkout-sidebar__section",
          },
          [
            _c("div", { staticClass: "spa-checkout-sidebar__guest-item" }, [
              _c("h3", { staticClass: "spa-checkout-sidebar__title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.tc(
                        "spaSoft.step1.guestTimeDateSelection.guestFieldLabel",
                        { guestNumber: Number(guestIndex) + 1 }
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "spa-checkout-sidebar__treatments-list" },
                _vm._l(guest.selectedTreatments, function (treatment) {
                  return _c(
                    "li",
                    {
                      key: "treatment-" + treatment.uuid,
                      staticClass: "spa-checkout-sidebar__treatment",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "spa-checkout-sidebar__treatment-price-wrapper",
                        },
                        [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "spa-checkout-sidebar__treatment-name",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    treatment.sitecoreTreatmentDetails.title
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "spa-checkout-sidebar__treatment-price",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getTreatmentPriceFormatted({
                                      treatment: treatment.selectedTimeSlot,
                                      checkTaxes: true,
                                    })
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "spa-checkout-sidebar__text--small" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getStartTime(treatment, guestIndex)) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "spa-checkout-sidebar__text--small" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(treatment.selectedTimeSlot.duration) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "spa-checkout-sidebar__text--small" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getGenderPreference(treatment)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "spa-checkout-sidebar__section",
          attrs: { "aria-labelledby": "taxes-title" },
        },
        [
          _c(
            "h3",
            {
              staticClass: "spa-checkout-sidebar__title",
              attrs: { id: "taxes-title" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.tc("spaSoft.step2.stayDetailsTaxesAndFees")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "spa-checkout-sidebar__row" }, [
            _c("span", { staticClass: "spa-checkout-sidebar__text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("spaSoft.step2.stayDetailsTotalTaxesAndFees")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "spa-checkout-sidebar__text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getTotalTaxes({ formatted: true })) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("toggle-details", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var opened = ref.opened
                  var toggle = ref.toggle
                  return _c(
                    "div",
                    { staticClass: "spa-checkout-sidebar__details" },
                    [
                      _c("transition", { attrs: { name: "expand-y" } }, [
                        opened
                          ? _c(
                              "ul",
                              {
                                staticClass:
                                  "spa-checkout-sidebar__details-tax-list",
                              },
                              _vm._l(
                                _vm.getTaxesList(),
                                function (treatmentTax, index) {
                                  return _c(
                                    "li",
                                    {
                                      key:
                                        index +
                                        "-" +
                                        treatmentTax.treatmentName,
                                      staticClass:
                                        "spa-checkout-sidebar__details-tax-group",
                                    },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "spa-checkout-sidebar__details-tax-items",
                                        },
                                        _vm._l(
                                          treatmentTax.taxes,
                                          function (tax, taxIndex) {
                                            return _c(
                                              "li",
                                              {
                                                key:
                                                  taxIndex +
                                                  "-" +
                                                  treatmentTax.treatmentName,
                                                staticClass:
                                                  "spa-checkout-sidebar__details-tax-item",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "spa-checkout-sidebar__text--small spa-checkout-sidebar__details-tax-name",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "spa-checkout-sidebar__details-tax-treatment",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            treatmentTax.treatmentName
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(_vm._s(tax.name)),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "spa-checkout-sidebar__text--small",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.getDisplayPrice({
                                                            price: tax.total,
                                                            withIsoCode: true,
                                                            fromCurrency:
                                                              _vm.propertyCurrency(),
                                                            toCurrency:
                                                              _vm.orSelected(
                                                                _vm.propertyCurrency()
                                                              ),
                                                          })
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "spa-checkout-sidebar__details-header",
                          attrs: {
                            type: "button",
                            "aria-expanded": opened ? "true" : "false",
                            "aria-controls": "tax-details",
                          },
                          on: { click: toggle },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "spa-checkout-sidebar__details-header-title",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.tc(
                                      "spaSoft.step2.stayDetailsTaxesDetailCta"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            class: opened ? "icon-minus" : "icon-add",
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "spa-checkout-sidebar__section",
          attrs: { "aria-labelledby": "total-cost-title" },
        },
        [
          _c("div", { staticClass: "spa-checkout-sidebar__row" }, [
            _c(
              "h3",
              {
                staticClass: "spa-checkout-sidebar__total-label",
                attrs: { id: "total-cost-title" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.tc("spaSoft.step2.stayDetailsEstimatedCost")) +
                    ":\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "spa-checkout-sidebar__total-amount" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.getTotalCost({ formatted: true })) +
                  "\n      "
              ),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }